export default {"src":"/_next/static/media/icon-twitter.55eaa176.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};